import Blue from "~/core";
import Swiper, {
  Navigation,
  Pagination,
  Controller,
	Autoplay,
	A11y
} from 'swiper';

Swiper.use([Navigation, Pagination, Controller, Autoplay, A11y]);


new Blue({
	name: 'Practices',
	selector: ".practice-list",
	setup(practicelist) {
    const uniqueClass = Date.now().toString(36) + Math.random().toString(36).substr(2);
		// add unique class to container element
		const container = practicelist.querySelector('.swiper-container');
		container.classList.add(`swiper-container--${uniqueClass}`)

    const nextEl = practicelist.parentElement.querySelector('.swiper-button-next');
		nextEl.classList.add(`swiper-button-next--${uniqueClass}`);
		// add unique class to prev button
		const prevEl = practicelist.parentElement.querySelector('.swiper-button-prev');
		prevEl.classList.add(`swiper-button-prev--${uniqueClass}`);

		
		let parentContainer = practicelist.closest("blue-composition") || practicelist.closest(".g");
		let isWidthLimited = !!parentContainer.closest("div[class*=g__c--md], div[class*=g__c--lg], div[class*=g__c--xl]");

    const swiperMain = new Swiper(container, {
      speed: 600,
      autoplay:true,
      navigation: {
        nextEl: `.swiper-button-next--${uniqueClass}`,
        prevEl: `.swiper-button-prev--${uniqueClass}`
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        800: {
          slidesPerView: isWidthLimited ? 2 : 3,
        },
        1024: {
          slidesPerView: isWidthLimited ? 3 : 4,
        }
      }
    });
	}
});